import { useTranslation } from 'react-i18next';
import { TextSkeleton, RectangleSkeleton } from '@treezor/design-system';

import { UserWalletOverview } from '@/features/wallets/components/Overview/UserWalletOverview';
import { useUserWalletList } from '@/features/wallets/hooks/useUserWalletList';

import { OverviewItemLoader } from './OverviewItemLoader';

export function UserWallet() {
  const { t } = useTranslation();
  const { isLoading, wallets } = useUserWalletList();

  if (!wallets?.length && isLoading)
    return (
      <div className="flex flex-col gap-5">
        <TextSkeleton width={120} margin="2px 0" />
        <div className="flex items-center gap-5">
          <RectangleSkeleton width={120} height={60} margin="0" />
          <RectangleSkeleton width={140} height={60} margin="0" />
          <RectangleSkeleton width={120} height={60} margin="0" />
        </div>
        <OverviewItemLoader />
        <OverviewItemLoader />
      </div>
    );

  if (!wallets?.length) return null;

  return (
    <div className="flex flex-col gap-5">
      <h6 className="typo-h6-bold text-secondary">{t('pages.currentProfiles.wallets.title')}</h6>
      <UserWalletOverview wallets={wallets} />
    </div>
  );
}
